import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: () => void;
}

export function ModalConfirmarExcluirProcessoFinanceiro({
  show,
  handleClose,
  onSubmit,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Excluir serviço"
      centered
    >
      <InfoContainer>
        <IconeContainer>
          <FaExclamation />
        </IconeContainer>
        <TextContainer>
          Deseja confirmar a exclusão do serviço selecionado?{" "}
          <strong>
            Após a confirmação, esta ação não poderá ser revertida.
          </strong>
        </TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "150px" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton style={{ width: "150px" }} onClick={onSubmit}>
          Excluir
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
